import { ECharts } from 'echarts/lib/echarts';
import kebabCase from 'lodash-es/kebabCase';

const saveChartWithTitle = (chartInstance: ECharts, title: string) => {
  const originalOptions = chartInstance.getOption();
  const originalWidth = chartInstance.getWidth();
  const originalHeight = chartInstance.getHeight();

  // Add title to chart and shift elements to make room for title
  chartInstance.setOption({
    animation: false,
    title: {
      text: title,
      top: 20,
      left: 30,
    },
    legend: {
      top: 80,
      left: 30,
    },
    grid: {
      top: 120,
      left: 50,
      right: 50,
      bottom: 50,
    },
  });

  // Resize chart to a set size, this will be the size of the image
  chartInstance.resize({
    width: 1200,
    height: 1000,
  });

  // Create image
  const image = chartInstance.getDataURL({
    type: 'jpeg',
    excludeComponents: ['toolbox'],
  });

  // Build image link and click it
  const anchor = document.createElement('a');
  anchor.href = image;
  anchor.download = kebabCase(title);
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  // Set chart back to original size
  chartInstance.resize({
    width: originalWidth,
    height: originalHeight,
  });

  // Revert changes
  chartInstance.setOption(originalOptions);
};

export default saveChartWithTitle;
